(ns practitest.frontend.components2.dashboard.transforms.line)

(defn- build-line-config
  [line-key {:keys [data line-configs colors-palette parse-date-fn parse-date-format]}]
  (let [{:keys [line-width line-name]} (get line-configs line-key)
        today-ts (js/Date.now)]
    {:line-data
     (mapv (fn [{:keys [date instance-runned]}]
             (let [parsed-date (parse-date-fn parse-date-format date)
                   y (if (and (= instance-runned 0)
                              (> (.getTime parsed-date) today-ts))
                       nil
                       instance-runned)]
               {:x-data   date
                :parsed-x parsed-date
                :y-data   y}))
           (get data line-key))

     :line-color (get colors-palette (name line-key))
     :line-width line-width
     :line-name  line-name}))

(defn- prepare-planned-vs-executed-data
  [data {:config/keys [line-configs parse-date-fn parse-date-format]} colors-palette]
  (let [params {:data              data
                :line-configs      line-configs
                :colors-palette    colors-palette
                :parse-date-fn     parse-date-fn
                :parse-date-format parse-date-format}]
    (mapv #(build-line-config % params)
          [:planned :executed])))

(defn transform-planned-vs-executed
  [{:chart/keys  [colors-palette] :as item}]
  (update item :chart/data prepare-planned-vs-executed-data item colors-palette))